{
  "Fremdsystem": "KDM",
  "Index1-2": "StWEP/MEP",
  "Index1-3": "StWEP/MEP",
  "layouts.page.title": "Grundbuch- und Vermessungsamt Basel-Stadt",
  "layouts.page.titleNavigation": "Navigation"
}
